import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './terms-and-conditions.css'

const TermsAndConditions = (props) => {
  return (
    <div className="terms-and-conditions-container1">
      <Helmet>
        <title>TermsAndConditions - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="TermsAndConditions - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="terms-and-conditions-text100">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="terms-and-conditions-text101">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="terms-and-conditions-text102">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="terms-and-conditions-text103">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="terms-and-conditions-text104">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="terms-and-conditions-text105">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="terms-and-conditions-text106">
              Cultivating Connection
            </span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="terms-and-conditions-text107">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="terms-and-conditions-text111">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name11"
        chargingPointLink1={
          <Fragment>
            <span className="terms-and-conditions-text112">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="terms-and-conditions-text113">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <div className="terms-and-conditions-container2">
        <div className="terms-and-conditions-container3">
          <React.Fragment>
            <React.Fragment>
              <Script>{`
  ;(function () {
    const backToTopBtn = document.getElementById("backToTop")
    const tocToggle = document.getElementById("tocToggle")
    const termsSidebar = document.getElementById("termsSidebar")
    const tocLinks = document.querySelectorAll(".toc-link")

    window.addEventListener("scroll", function () {
      if (window.pageYOffset > 300) {
        backToTopBtn.classList.add("visible")
      } else {
        backToTopBtn.classList.remove("visible")
      }

      updateActiveSection()
    })

    backToTopBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    })

    tocToggle.addEventListener("click", function () {
      termsSidebar.classList.toggle("active")
    })

    termsSidebar.addEventListener("click", function (e) {
      if (window.innerWidth <= 767 && e.target.classList.contains("toc-link")) {
        termsSidebar.classList.remove("active")
      }
    })

    document.addEventListener("click", function (e) {
      if (
        window.innerWidth <= 767 &&
        !termsSidebar.contains(e.target) &&
        !tocToggle.contains(e.target) &&
        termsSidebar.classList.contains("active")
      ) {
        termsSidebar.classList.remove("active")
      }
    })

    function updateActiveSection() {
      const sections = document.querySelectorAll(".terms-section")
      let currentSection = ""

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100
        if (window.pageYOffset >= sectionTop) {
          currentSection = section.getAttribute("id")
        }
      })

      tocLinks.forEach((link) => {
        link.classList.remove("active")
        if (link.getAttribute("href") === \`#\${currentSection}\`) {
          link.classList.add("active")
        }
      })
    }

    updateActiveSection()
  })()
`}</Script>
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div className="terms-container">
        <div className="terms-hero">
          <div className="terms-and-conditions-terms-hero-content terms-hero-content">
            <div className="terms-badge">
              <span>Legal Document</span>
            </div>
            <h1 className="terms-and-conditions-terms-main-title terms-main-title">
              iCharge Terms &amp; Conditions
            </h1>
            <p className="terms-subtitle">Last updated September, 2025</p>
            <div className="terms-hero-decoration"></div>
          </div>
        </div>
        <button
          id="tocToggle"
          aria-label="Toggle table of contents"
          className="toc-mobile-toggle"
        >
          <svg
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M4 5h16M4 12h16M4 19h16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
          <span>Table of Contents</span>
        </button>
        <div className="terms-layout">
          <aside id="termsSidebar" className="terms-sidebar">
            <div className="toc-header">
              <h2>Table of Contents</h2>
            </div>
            <nav className="toc-nav">
              <a href="#section-1">
                <div className="toc-link">
                  <span className="toc-number">01</span>
                  <span className="toc-text">Your acceptance</span>
                </div>
              </a>
              <a href="#section-2">
                <div className="toc-link">
                  <span className="toc-number">02</span>
                  <span className="toc-text">Registering an Account</span>
                </div>
              </a>
              <a href="#section-3">
                <div className="toc-link">
                  <span className="toc-number">03</span>
                  <span className="toc-text">
                    Provision of Charging Stations
                  </span>
                </div>
              </a>
              <a href="#section-4">
                <div className="toc-link">
                  <span className="toc-number">04</span>
                  <span className="toc-text">
                    Use of Charging Stations and fair use
                  </span>
                </div>
              </a>
              <a href="#section-5">
                <div className="toc-link">
                  <span className="toc-number">05</span>
                  <span className="toc-text">EVSE Idle Fee</span>
                </div>
              </a>
              <a href="#section-6">
                <div className="toc-link">
                  <span className="toc-number">06</span>
                  <span className="toc-text">
                    Charging Stations owned by CPO
                  </span>
                </div>
              </a>
              <a href="#section-7">
                <div className="toc-link">
                  <span className="toc-number">07</span>
                  <span className="toc-text">Use of iCharge Apps</span>
                </div>
              </a>
              <a href="#section-8">
                <div className="toc-link">
                  <span className="toc-number">08</span>
                  <span className="toc-text">
                    Content of iCharge Apps and Website
                  </span>
                </div>
              </a>
              <a href="#section-9">
                <div className="toc-link">
                  <span className="toc-number">09</span>
                  <span className="toc-text">Links on the Website</span>
                </div>
              </a>
              <a href="#section-10">
                <div className="toc-link">
                  <span className="toc-number">10</span>
                  <span className="toc-text">
                    Access to iCharge Apps and Website
                  </span>
                </div>
              </a>
              <a href="#section-11">
                <div className="toc-link">
                  <span className="toc-number">11</span>
                  <span className="toc-text">Indemnity</span>
                </div>
              </a>
              <a href="#section-12">
                <div className="toc-link">
                  <span className="toc-number">12</span>
                  <span className="toc-text">
                    {' '}
                    Warranties, consumer guarantees and limitation of liability
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </a>
              <a href="#section-13">
                <div className="toc-link">
                  <span className="toc-number">13</span>
                  <span className="toc-text">Termination of your Account</span>
                </div>
              </a>
              <a href="#section-14">
                <div className="toc-link">
                  <span className="toc-number">14</span>
                  <span className="toc-text">Privacy</span>
                </div>
              </a>
              <a href="#section-15">
                <div className="toc-link">
                  <span className="toc-number">15</span>
                  <span className="toc-text">Competitors</span>
                </div>
              </a>
              <a href="#section-16">
                <div className="toc-link">
                  <span className="toc-number">16</span>
                  <span className="toc-text">Jurisdiction and law</span>
                </div>
              </a>
              <a href="#section-17">
                <div className="toc-link">
                  <span className="toc-number">17</span>
                  <span className="toc-text">Severability</span>
                </div>
              </a>
              <a href="#section-18">
                <div className="toc-link">
                  <span className="toc-number">18</span>
                  <span className="toc-text">Contacting us</span>
                </div>
              </a>
            </nav>
          </aside>
          <main className="terms-content">
            <section id="section-1" className="terms-section">
              <div className="section-marker">
                <span>01</span>
              </div>
              <h2 className="section-title">Your acceptance</h2>
              <div className="subsection">
                <h3 className="subsection-number">1.1</h3>
                <p>
                  {' '}
                  These are the terms and conditions &quot;Terms&quot; on which
                  iCharge (referred to as iCharge, we, our or us) permits users
                  (referred to as you or your) to: (a) use the iCharge
                  open-platform network of electric vehicle charging stations
                  (Charging Stations), including all electric vehicle service
                  equipment (EVSE), the electric vehicle charging applications
                  it delivers, and all support network infrastructure and
                  services supplied by ICharge in respect of the Charging
                  Stations (iCharge Network); and (b) access and use the iCharge
                  apps which provide data in respect of the iCharge Network
                  (iCharge Apps) and the iCharge website, located at iCharge.com
                  (Website).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">1.2</h3>
                <p>
                  {' '}
                  You agree to be bound by these Terms when you: (a) apply for a
                  subscription or register an account to use the iCharge
                  Network; (b) use any piece of EVSE located at a Charging
                  Station; or (c) use, browse or access any part of the iCharge
                  Apps or Website.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">1.3</h3>
                <p>
                  {' '}
                  If you access a Charging Station using an electric vehicle
                  (EV) which does not belong to you, the act of doing so will
                  also bind the owner of the EV you are driving and warrant your
                  authority to do so.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">1.4</h3>
                <p>
                  {' '}
                  iCharge may from time-to-time review and update these Terms
                  and the iCharge Privacy Policy (a copy of which can be found
                  on the Website) to take account of new laws, regulations,
                  products, technology or other relevant changes in
                  circumstances. Your use of the iCharge Network, iCharge Apps
                  and Website will be governed by the most recent Terms posted
                  on the Website. By continuing to use the iCharge Network,
                  iCharge Apps or Website, you agree to be bound by the most
                  recent Terms. It is your responsibility to check the Website
                  regularly for updated versions of the Terms.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-2" className="terms-section">
              <div className="section-marker">
                <span>02</span>
              </div>
              <h2 className="section-title">Registering an Account</h2>
              <div className="subsection">
                <h3 className="subsection-number">2.1</h3>
                <p>
                  {' '}
                  You may be required to register an account in order to use the
                  iCharge Network (Account).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.2</h3>
                <p>
                  {' '}
                  You warrant that all information and data provided by you in
                  the process of registering an Account is accurate, complete
                  and up to date. You will promptly inform iCharge if there is
                  any subsequent change to your information or data.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.3</h3>
                <p>
                  {' '}
                  By registering an Account, you warrant to us that: (a) you are
                  authorised and have full power and capacity to register and
                  control all EVs whose VINs are associated with your Account
                  and will notify iCharge, through the iCharge App or using the
                  contact details outlined in clause 19, in the event that you
                  are no longer authorised to register or control an EV so that
                  the VIN can be removed from your Account; and (b) you are at
                  least 16 years of age and possess the legal authority to enter
                  into and use the iCharge Network, the iCharge Apps and the
                  Website in accordance with these Terms and the law.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.4</h3>
                <p>
                  {' '}
                  You agree to be financially responsible for all use of the
                  iCharge Network (as well as for use by others of the iCharge
                  Network to charge your EV), and to pay all applicable Fees (as
                  defined in clause 2.5) for access to a Charging Station
                  initiated by you or attributed to an EV or iCharge RFID card
                  (RFID Card) which is associated with your Account. In
                  particular, you agree to: (a) promptly review your payment
                  method statement (such as your credit card statement) and
                  notify iCharge customer service in writing of any questions
                  regarding Fees. Fees not questioned by this method within 30
                  days of the applicable statement date will be deemed valid;
                  and (b) promptly update your Account information with any
                  changes to your name, email address, mailing address,
                  telephone number and any applicable credit card information.
                  Account information can be updated through the iCharge Apps or
                  the Website (if applicable).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.5</h3>
                <p>
                  {' '}
                  For the purposes of these Terms, the amount payable by you for
                  your use of the iCharge Network includes: (a) your usage fee,
                  being the kWh rate advertised with respect to each Charging
                  Station plus any applicable taxes; and (b) any applicable Idle
                  Fees (as defined in clause 5.2) charged in accordance with
                  these Terms, (collectively, the &quot;Fees&quot;).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.6</h3>
                <p>
                  {' '}
                  In the event that payment on your credit card or other payment
                  method is declined you must rectify this immediately and
                  failure to do so may result in iCharge terminating your
                  Account. In the event iCharge terminates your Account, iCharge
                  may institute collection proceedings in order to collect any
                  unpaid balance on your Account and any fees, costs or other
                  expenses incurred by iCharge in connection with its collection
                  efforts.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.7</h3>
                <p>
                  {' '}
                  In the event that your RFID Card is lost, stolen or damaged,
                  you must promptly notify iCharge in accordance with the
                  contact details provided in clause 19. ICharge will, within
                  seven (7) days, remove the RFID Card from your Account (Notice
                  Period). You agree that any usage associated with your RFID
                  Card during the Notice Period remains a Fee payable by you.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.8</h3>
                <p>
                  {' '}
                  You agree to not attempt to scrape, decompile, data-mine,
                  reverse engineer, disassemble, or otherwise deal with the
                  iCharge App, Website, iCharge Network or any Charging Stations
                  or EVSE, in any way other than as it is intended to be used
                  and as is permitted by these Terms.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.9</h3>
                <p>
                  {' '}
                  iCharge reserves the right to modify and/or apply different
                  prices and fees for charging services, depending on the type
                  of charging point (EVSE), its location, and the time intervals
                  of usage.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.10</h3>
                <p>
                  {' '}
                  For the same charging point (EVSE) and the same time interval,
                  iCharge may apply different prices to different users, in
                  accordance with its commercial policies and/or the performance
                  criteria of the user.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.11</h3>
                <p>
                  {' '}
                  Based on the user&apos;s performance, usage history, or other
                  criteria determined by iCharge, the company reserves the right
                  to apply higher or lower prices compared to other users.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.12</h3>
                <p>
                  {' '}
                  iCharge does not guarantee full consistency between the price
                  displayed in the application and the price that may be shown
                  on the screen of the charging point (EVSE). In the event of
                  any discrepancy, including those arising from technical
                  circumstances or agreements with Charging Point Operators
                  (CPOs), the final and binding price shall be the one applied
                  through the iCharge application.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">2.13</h3>
                <p>
                  {' '}
                  The provisions of this section apply to all charging points
                  where iCharge provides services through agreements with
                  third-party Charging Point Operators (CPOs), both within and
                  outside the territory of the Republic of Albania, collectively
                  referred to as the &quot;Roaming&quot; network.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-3" className="terms-section">
              <div className="section-marker">
                <span>03</span>
              </div>
              <h2 className="section-title">Provision of Charging Stations</h2>
              <div className="subsection">
                <h3 className="subsection-number">3.1</h3>
                <p>
                  {' '}
                  iCharge provides access to Charging Stations which are owned
                  and maintained by third parties. Nothing in these Terms or
                  otherwise inferred by your use of the Charging Stations places
                  any obligation on iCharge to maintain Charging Stations. Such
                  obligation is borne solely by the third-party charge point
                  operator (CPO) who owns the Charging Stations (subject to any
                  relevant third-party CPO terms and conditions as detailed
                  under clause 7).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">3.2</h3>
                <p>
                  {' '}
                  iCharge may, from time to time, make available the Charging
                  Stations for use by Account holders to charge their EV.
                  iCharge reserves the right, at its discretion (acting
                  reasonably), to refuse or suspend access to any or all
                  Charging Stations to any person (including but not limited to
                  any person found to be in breach of these Terms).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">3.3</h3>
                <p>
                  {' '}
                  You acknowledge that in the event iCharge refuses or suspends
                  access to any or all Charging Stations, iCharge will (if
                  practicable) generally attempt to provide notice to the
                  contact details associated with an Account, however, in
                  certain circumstances it is not practicable for ICharge to
                  provide notice. In such circumstances, iCharge reserves the
                  right to not provide notice.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">3.4</h3>
                <p>
                  {' '}
                  iCharge may refuse or suspend the use of the iCharge Network,
                  or any Charging Station or EVSE, at any time and will
                  endeavour to update the iCharge App or Website, in the event:
                  (a) one or more piece of EVSE requires maintenance or
                  upgrading; or (b) a provision of the iCharge Network is
                  disrupted or prevented as a result of an event outside
                  iCharge&apos;s reasonable control or for safety reasons,
                  (being Service Interruptions), however iCharge does not
                  guarantee that prior notice of Service Interruptions will be
                  provided to you.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">3.5</h3>
                <p>
                  {' '}
                  iCharge may refuse or suspend the use of the iCharge Network,
                  or any Charging Station or EVSE, at any time and without
                  notice to you, if we have a reasonable belief that the iCharge
                  Network or a Charging Station is being used unethically,
                  unlawfully or contrary to any law or regulation.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">3.6</h3>
                <p>
                  {' '}
                  iCharge does not guarantee, and is under no obligation to
                  ensure, the availability, compatibility with your EV, or
                  performance of Charging Stations, nor does it promise to
                  provide an uninterrupted electricity supply to Charging
                  Stations. iCharge cannot guarantee that connecting your EV to
                  one of our Charging Stations will result in a successful and
                  timely recharge of your EV&apos;s battery or batteries.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">3.7</h3>
                <p>
                  {' '}
                  If there are any faults or you have any issues with any
                  Charging Station, please contact us as soon as possible using
                  the contact details outlined in clause 18.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-4" className="terms-section">
              <div className="section-marker">
                <span>04</span>
              </div>
              <h2 className="section-title">
                Use of Charging Stations and fair use
              </h2>
              <div className="subsection">
                <h3 className="subsection-number">4.1</h3>
                <p>
                  {' '}
                  Your use of the Charging Stations and any prepaid charging
                  packs, e-vouchers, gift cards (if applicable) must be fair,
                  reasonable, not excessive and in an acceptable manner. If we
                  consider, in our reasonable discretion, your usage to be
                  unfair, unreasonable, excessive or in an unacceptable manner
                  (collectively, Unreasonable Conduct), without limiting clause
                  3 above, we may immediately suspend, terminate, modify or
                  restrict your access to any or all Charging Stations. We may
                  consider your use of the Charging Stations to be Unreasonable
                  Conduct if you use Charging Stations in a manner other than
                  they are intended for. Below are some examples of uses that we
                  consider Unreasonable Conduct. This is not intended to be an
                  exhaustive list: (a) using or accessing the Charging Stations
                  in a manner that breaches these Terms or any applicable laws
                  and regulations; (b) using the Charging Stations for any
                  fraudulent purpose; (c) in the case of iCharge&apos;
                  subscription charging service, using your Account to provide
                  anyone other than yourself, access to free charging on the
                  iCharge Network; or (d) using the Charging Stations and
                  iCharge Network in a manner that could interfere with the
                  service, our networks, the assets and equipment of us or a CPO
                  or our ability to provide services to you or another person.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.2</h3>
                <p>
                  {' '}
                  You agree not to use, or attempt to use, Charging Stations for
                  any purpose other than to charge your EV and then only to the
                  extent that your EV is compatible with the Charging Stations.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.3</h3>
                <p>
                  {' '}
                  When using the Charging Stations, you agree to comply with all
                  applicable laws and regulations. In particular, you agree to:
                  (a) take reasonable care for your own health and safety; (b)
                  take reasonable care that your acts or omissions do not
                  adversely affect the health and safety of others; (c) comply,
                  as far as you are reasonably able to, with any reasonable
                  instruction that is given by iCharge or the relevant CPO. This
                  means complying with the relevant EV manufacturer&apos;s
                  handbook and any instructions for use set out at the Charging
                  Stations (which may be updated by iCharge or a CPO from time
                  to time and so should be reviewed by you each time you use a
                  Charging Station); and (d) be aware of any parking
                  restrictions which may be being enforced nearby or attached to
                  the Charging Station.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.4</h3>
                <p>
                  {' '}
                  When using the Charging Stations, you must ensure that the
                  EVSE located at that Charging Station is compatible with your
                  EV, including that the charging cable is suitable for use on
                  your EV.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.5</h3>
                <p>
                  {' '}
                  You warrant to us that your EV is roadworthy and is registered
                  for use on Australian roads, that you have read the relevant
                  manufacturer&apos;s EV handbook and that the EV does not
                  present any danger or risk to other vehicles or persons or to
                  the Charging Stations.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.6</h3>
                <p>
                  {' '}
                  Where you are not the owner of the EV accessing the Charging
                  Station, you warrant that you are authorised by the owner of
                  that EV to use the Charging Station and that you have
                  authority to bind the owner to these Terms.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.7</h3>
                <p>
                  {' '}
                  You acknowledge that we are not supervising your use of the
                  Charging Stations and that you and any people with you are
                  undertaking such use at your own risk.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">4.8</h3>
                <p>
                  {' '}
                  You acknowledge that where Charging Stations are located on
                  private property, you agree to keep the property clean and
                  tidy, and to comply with all reasonable requests of the owner
                  of that property provided from time to time when using the
                  relevant Charging Stations, including any request to
                  immediately suspend, modify or restrict your access to that
                  Charging Station.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-5" className="terms-section">
              <div className="section-marker">
                <span>05</span>
              </div>
              <h2 className="section-title">EVSE Idle Fee</h2>
              <div className="subsection">
                <h3 className="subsection-number">5.1</h3>
                <p>
                  {' '}
                  You agree that you will remove your EV from a Charging Station
                  promptly once it is charged and ensure that access to the EVSE
                  and Charging Station is cleared to allow other users to use
                  the EVSE and Charging Station.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">5.2</h3>
                <p>
                  {' '}
                  You acknowledge and agree that you may incur an idle fee for
                  the time your EV remains parked in a charging stall after it
                  is finished charging (Idle Fee). To avoid Idle Fees, we
                  recommend you monitor your EV while using a Charging Station
                  and use the iCharge Apps to track your EV&apos;s charge
                  status.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-6" className="terms-section">
              <div className="section-marker">
                <span>06</span>
              </div>
              <h2 className="section-title">Charging Stations owned by CPO</h2>
              <div className="subsection">
                <h3 className="subsection-number">6.1</h3>
                <p>
                  {' '}
                  When using a Charging Station on the iCharge Network that is
                  operated or owned by a third-party CPO, you will be deemed to
                  have accepted the terms and conditions of use of the
                  third-party CPO that operates or owns the Charging Station
                  (CPO T&amp;Cs).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">6.2</h3>
                <p>
                  {' '}
                  The third-party CPOs which currently own or operate Charging
                  Stations on the iCharge Network and their terms and conditions
                  of use can be accessed here.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">6.3</h3>
                <p>
                  {' '}
                  iCharge will use reasonable endeavours to notify you of the
                  Charging Stations on the iCharge Network which are operated or
                  owned by a third-party CPO and provide access to the relevant
                  CPO T&amp;Cs in these Terms and on the iCharge Website and/or
                  iCharge App.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">6.4</h3>
                <p>
                  {' '}
                  In the event of any inconsistency between these Terms and a
                  CPO T&amp;Cs, the Terms which imposes a higher standard on you
                  will prevail to the extent of any inconsistency.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">6.5</h3>
                <p>
                  {' '}
                  iCharge does not guarantee that the CPO T&amp;Cs accessible in
                  these Terms or on the iCharge App or Website are the most up
                  to date versions of those CPO T&amp;Cs. You are solely
                  responsible for ensuring that you have read any relevant CPO
                  T&amp;Cs and are aware of any updates that may be made to CPO
                  T&amp;Cs from time to time. By using and continuing to use a
                  Charging Station owned or operated by a third-party CPO you
                  agree to be bound by the most recent terms of the relevant CPO
                  T&amp;Cs.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">6.6</h3>
                <p>
                  {' '}
                  You agree that iCharge is in no way liable to you (a) under
                  any CPO T&amp;Cs, or (b) in the event the CPO T&amp;Cs
                  accessible in these Terms or on the iCharge App or Website are
                  not the most up to date version of the relevant CPO T&amp;Cs,
                  and you irrevocably release iCharge from any such claim.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-7" className="terms-section">
              <div className="section-marker">
                <span>07</span>
              </div>
              <h2 className="section-title">Use of iCharge Apps</h2>
              <div className="subsection">
                <h3 className="subsection-number">7.1</h3>
                <p>
                  {' '}
                  You may access and use the iCharge Apps or the Website to
                  obtain information regarding Charging Station locations and
                  other content and features that iCharge may make available.
                  Use of the iCharge Apps and the Website is subject to these
                  Terms, iCharge&apos;s Privacy Policy (available on the
                  Website), any relevant mobile application terms and conditions
                  entered into at the time of downloading the iCharge Apps.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">7.2</h3>
                <p>
                  {' '}
                  You are responsible for all use of the iCharge Apps under your
                  Account name.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-8" className="terms-section">
              <div className="section-marker">
                <span>08</span>
              </div>
              <h2 className="section-title">
                Content of iCharge Apps and Website
              </h2>
              <div className="subsection">
                <h3 className="subsection-number">8.1</h3>
                <p>
                  {' '}
                  The iCharge Apps and Website are owned and operated by or on
                  behalf of iCharge.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">8.2</h3>
                <p>
                  {' '}
                  All intellectual property rights (including copyright and
                  patents) in the information, comment, content, communication,
                  advice, text, trademarks, logos, service names and trade names
                  of iCharge, images of people or places or other content
                  (Content) contained in the iCharge Apps, on the Website or
                  otherwise provided to you by iCharge is owned or licensed by
                  iCharge.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">8.3</h3>
                <p>
                  {' '}
                  The Content in the iCharge Apps and on the Website and any
                  other information provided to you is for general information
                  purposes only. You acknowledge and agree that, while iCharge
                  has attempted to provide accurate information through the
                  iCharge Apps and on the Website, such information may change
                  frequently and in no event will iCharge be responsible for the
                  accuracy, usefulness or completeness of the Content in the
                  iCharge Apps and on the Website, nor does it warrant that any
                  such Content is the most current version thereof. To the
                  maximum extent permitted by applicable law, iCharge does not
                  warrant or make any representations as to any third-party
                  products or services described or referred to in the iCharge
                  Apps, on the Website or otherwise. Any use of the Content by
                  another person or organisation is at the user&apos;s own risk.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">8.4</h3>
                <p>
                  {' '}
                  The Content in the iCharge Apps and on the Website is obtained
                  and developed from a variety of sources including but not
                  limited to collaborations with third parties and information
                  provided by third parties under licence or agreement.
                  Inclusion of Content in the iCharge Apps or on the Website is
                  not an endorsement of any organisation, product or service.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">8.5</h3>
                <p>
                  {' '}
                  iCharge may modify any information in the iCharge Apps or on
                  the Website (including Content) at our absolute discretion for
                  any reason, without notice. All updates and modifications to
                  the iCharge Apps or the Website (including Content) will be
                  subject to these Terms.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">8.6</h3>
                <p>
                  {' '}
                  If you have a complaint regarding any Content in the iCharge
                  Apps or on the Website, iCharge will review any written
                  complaint notified to it in accordance with clause 18 and may,
                  at its sole discretion, modify or remove the relevant Content.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-9" className="terms-section">
              <div className="section-marker">
                <span>09</span>
              </div>
              <h2 className="section-title">Links on the Website</h2>
              <div className="subsection">
                <h3 className="subsection-number">9.1</h3>
                <p>
                  {' '}
                  The Website may contain links to other websites (including the
                  websites of CPOs). We have not reviewed all of the third-party
                  websites linked on the Website and are not responsible for
                  their content or accuracy. iCharge provides those website
                  links for reasons such as for searching for third-party goods
                  and services on the internet and, unless otherwise stated, not
                  as an endorsement, support or sponsorship of those websites,
                  their operators, the goods, services or content that they
                  describe.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">9.2</h3>
                <p>
                  {' '}
                  Social Media and other websites (including the websites of
                  CPOs) which are linked to the Website, are not covered by
                  these Terms, and may have their own terms and conditions and
                  privacy policy. If you choose to access any linked sites, you
                  do so at your own risk. iCharge is not responsible for and
                  will not be liable in respect of the content or operation of
                  those websites or any of the goods, services or content that
                  they describe. iCharge is not responsible for and will not be
                  liable in respect of any incorrect link to an external
                  website.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-10" className="terms-section">
              <div className="section-marker">
                <span>10</span>
              </div>
              <h2 className="section-title">
                Access to iCharge Apps and Website
              </h2>
              <div className="subsection">
                <h3 className="subsection-number">10.1</h3>
                <p>
                  {' '}
                  iCharge does not guarantee or warrant that you will have
                  continuous access to the iCharge Apps or Website. Subject to
                  these Terms, iCharge will not be liable if the iCharge Apps or
                  Website are unavailable to you for any reason, including due
                  to computer downtime attributable to malfunctions, upgrades,
                  preventative or remedial maintenance activities or
                  interruption in telecommunications supply.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">10.2</h3>
                <p>
                  {' '}
                  iCharge does not guarantee the delivery or security of
                  communications over the internet as such communications rely
                  on third-party service providers, and electronic communication
                  (including electronic mail) is vulnerable to interception by
                  third parties.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">10.3</h3>
                <p>
                  {' '}
                  Whilst iCharge takes reasonable precautions to protect
                  information transmitted via the iCharge Apps and Website,
                  subject to applicable laws, iCharge cannot and does not
                  guarantee the security or confidentiality of these
                  communications or the security of the iCharge Apps or Website.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">10.4</h3>
                <p>
                  {' '}
                  iCharge does not provide, and has no control over,
                  communications, networks or services, the internet or other
                  technology required or used across the iCharge Apps or Website
                  and, to the maximum extent permitted under applicable law,
                  accepts no responsibility for any direct or indirect loss in
                  any form associated with them, whether due to congestion,
                  technical malfunction, viruses or otherwise.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-11" className="terms-section">
              <div className="section-marker">
                <span>11</span>
              </div>
              <h2 className="section-title">Indemnity</h2>
              <div className="subsection">
                <h3 className="subsection-number">11.1</h3>
                <p>
                  {' '}
                  You will fully indemnify ICharge in respect of all loss,
                  damage, costs, expenses (including reasonable legal fees on a
                  full indemnity basis), fines, penalties, claims, demands and
                  proceedings howsoever arising, whether at common law
                  (including negligence) or under statute (Loss), in connection
                  with any of the following: (a) any breach of these Terms or a
                  CPO&apos;s T&amp;Cs by you; (b) your use or misuse of the
                  Charging Stations, EVSE, iCharge Network, the iCharge Apps and
                  the Website; or (c) your communications with iCharge, except
                  to the extent such Loss is contributed to by the gross
                  negligence or wilful misconduct of iCharge.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">11.2</h3>
                <p>
                  {' '}
                  iCharge will indemnify you in respect of any Losses incurred
                  by you to the extent such Loss arises directly from a breach
                  of these Terms by iCharge.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-12" className="terms-section">
              <div className="section-marker">
                <span>12</span>
              </div>
              <h2 className="section-title">
                {' '}
                Warranties, consumer guarantees and limitation of liability
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </h2>
              <div className="subsection">
                <h3 className="subsection-number">12.1</h3>
                <p>
                  {' '}
                  Your use of the Charging Stations and related EVSE, iCharge
                  Network, iCharge Apps and Website is at your own risk.
                  iCharge&apos;s services are provided on an &apos;as is&apos;
                  and &apos;as available&apos; basis.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.2</h3>
                <p>
                  {' '}
                  Any representation, warranty, condition, guarantee or
                  undertaking that would be implied in these Terms in relation
                  to any service supplied by iCharge by legislation, common law,
                  equity, trade, custom or usage is excluded to the maximum
                  extent permitted by law, including any implied warranties of
                  acceptable quality or fitness for a disclosed purpose.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.3</h3>
                <p>
                  {' '}
                  Nothing in these Terms excludes, restricts or modifies any
                  consumer guarantee, right or remedy conferred on you by the
                  Albanian Consumer Law, set out in the Competition and Consumer
                  Law or any other applicable law that cannot be excluded,
                  restricted or modified by agreement.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.4</h3>
                <p>
                  {' '}
                  Our services come with guarantees that cannot be excluded
                  under the ACL. For major failures with the service, you are
                  entitled: (a) to cancel your Account with us; and (b) to a
                  refund for the unused services or credit on your Account;
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.5</h3>
                <p>
                  {' '}
                  You are also entitled to be compensated for any other
                  reasonably foreseeable loss or damage. If the failure does not
                  amount to a major failure you are entitled to have problems
                  with the service rectified in a reasonable time and, if this
                  is not done, to cancel your subscription or Account with us
                  and obtain a refund for any unused services or credit on your
                  subscription or Account.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.6</h3>
                <p>
                  {' '}
                  iCharge will not be liable to you for any damage of any kind
                  to your EV whatsoever, arising from a failure by you to
                  exercise reasonable care or comply with the requirements of
                  the EV manufacturer&apos;s handbook or with iCharge&apos;s or
                  a CPO&apos;s instructions. To the maximum extent permitted by
                  law, you agree to hold iCharge harmless against any liability,
                  or Losses which you may suffer or incur as a result of a
                  failure by you to comply with one or more of the following:
                  the EV manufacturer&apos;s handbook, iCharge&apos;s or a
                  CPO&apos;s instructions, or your obligations under any
                  applicable laws and regulations.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.7</h3>
                <p>
                  {' '}
                  iCharge will not be liable to you for any loss or damage to
                  you or your EV, that are indirect, incidental, special or
                  consequential loss or damage, loss of profits or anticipated
                  profits, economic loss, loss of business opportunity, loss of
                  data, loss of reputation or loss of revenue (irrespective of
                  whether the loss or damage is caused by or relates to breach
                  of contract, tort (including negligence), statute or
                  otherwise) (Consequential Losses) arising in connection with
                  your use of the iCharge Network, the iCharge Apps, the Website
                  and all links to or from the Website unless, and to the
                  extent, that such Consequential Losses are directly caused by:
                  (a) the gross negligence of iCharge; or (b) the fraud or
                  wilful breach by iCharge of any of its obligations under these
                  Terms, provided that such Consequential Losses are reasonably
                  foreseeable and are not caused by something beyond
                  iCharge&apos;s control (including, for the avoidance of doubt,
                  any act or omission of any third-party, any Force Majeure
                  Event (defined under clause 13.10 below), any incompatibility
                  of your EV with the EVSE, the enforcement of parking
                  restrictions by law enforcement officials, or any breach by
                  you of these Terms or a CPOs T&amp;Cs).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.8</h3>
                <p>
                  {' '}
                  You will not be liable to iCharge for any Consequential Losses
                  incurred by iCharge which arise in connection with your use of
                  the iCharge Network, the iCharge Apps and the Website unless,
                  and to the extent that such Consequential Losses are directly
                  caused by: (a) your gross negligence; or (b) your fraud or
                  wilful breach of your obligations under these Terms, provided
                  that such Consequential Losses are reasonably foreseeable and
                  are not caused by something beyond your control (including,
                  for the avoidance of doubt, any act or omission of any
                  third-party or any Force Majeure Event).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.9</h3>
                <p>
                  {' '}
                  Subject to this clause 13, to the maximum extent permitted by
                  law, the maximum aggregate liability of a party for all proven
                  losses, damages and claims arising out of or in connection
                  with these Terms or a supply under these Terms, including
                  liability for breach, in negligence or in tort or for any
                  other common law or statutory action, is limited to the sum of
                  AU$2,000,000.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">12.10</h3>
                <p>
                  {' '}
                  For the purposes of this clause 13, Force Majeure Event is
                  defined as a strike, riot, war, flood, bushfire, earthquake or
                  other natural disaster event, pandemic, border closure, state
                  of emergency, any power outage or telecommunication facilities
                  outage.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-13" className="terms-section">
              <div className="section-marker">
                <span>13</span>
              </div>
              <h2 className="section-title">Termination of your Account</h2>
              <div className="subsection">
                <h3 className="subsection-number">13.1</h3>
                <p>
                  {' '}
                  iCharge may, acting reasonably, at any time and without prior
                  notice, immediately terminate your Account, including
                  restricting access to the iCharge Network, the iCharge Apps or
                  any feature of the iCharge Apps or the Website, for any reason
                  (including due to your breach or alleged breach of these
                  Terms).
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">13.2</h3>
                <p>
                  {' '}
                  Any indemnities given under these Terms and any limitations of
                  liability survive termination.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">13.3</h3>
                <p>
                  {' '}
                  You may terminate your Account at any time by providing
                  iCharge with written notice in accordance with clause 19 or by
                  deleting your Account on the iCharge App.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">13.4</h3>
                <p>
                  {' '}
                  Following any termination, you will remain responsible for any
                  and all unpaid Fees and charges associated with your Account.
                  If such unpaid Fees and charges are not promptly remitted, you
                  may become liable for additional service charges, fees or
                  penalties, and you may be subject to collection actions and
                  fees associated with the recovery by iCharge from you of any
                  unpaid balance.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-14" className="terms-section">
              <div className="section-marker">
                <span>14</span>
              </div>
              <h2 className="section-title">Privacy</h2>
              <div className="subsection">
                <h3 className="subsection-number">14.1</h3>
                <p>
                  {' '}
                  In registering for an Account and using the iCharge Network,
                  iCharge Apps or Website, you may provide certain personal
                  information to iCharge and you agree that any information
                  collected by iCharge may be accessed or collected for use by
                  iCharge or any of its related companies or business partners
                  in the course of its business (including direct marketing
                  activities) in accordance with iCharge&apos;s Privacy Policy
                  (available at the Website and as updated from time to time in
                  accordance with its terms). When using a Charging Station on
                  the iCharge Network that is operated or owned by a third-party
                  CPO, that CPO&apos;s privacy policy will also apply.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
              <div className="subsection">
                <h3 className="subsection-number">14.2</h3>
                <p>
                  {' '}
                  By using the iCharge Network, iCharge App or Website you agree
                  that iCharge may view, monitor, and record your activity (in
                  accordance with the iCharge Privacy Policy) without providing
                  further notice or requesting your permission. Any data or
                  information obtained by monitoring, reviewing, or recording
                  your activity may be reviewed by law enforcement organisations
                  in connection with investigation or prosecution of possible
                  criminal or unlawful activity on the iCharge Network, iCharge
                  App and Website as well as for disclosures required by or
                  under applicable law or related government agency actions.
                  iCharge will also comply with all court orders or subpoenas
                  involving requests for such data and information.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-15" className="terms-section">
              <div className="section-marker">
                <span>15</span>
              </div>
              <h2 className="section-title">Competitors</h2>
              <div className="subsection">
                <p>
                  {' '}
                  If you are in the business of providing similar services to
                  iCharge, whether for business users or domestic users, then
                  you are a competitor of iCharge. Competitors are not permitted
                  to use or access any information or content on the iCharge
                  Website or the iCharge App without iCharge&apos;s written
                  consent. If you breach this clause, iCharge may hold you fully
                  responsible for any Loss that we may sustain from such a
                  breach.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-16" className="terms-section">
              <div className="section-marker">
                <span>16</span>
              </div>
              <h2 className="section-title">Jurisdiction and law</h2>
              <div className="subsection">
                <p>
                  {' '}
                  These Terms are governed by and must be construed in
                  accordance with the laws of the State of Albania. You submit
                  to the exclusive jurisdiction of the courts of the State of
                  Albania and in respect of all matters arising out of or
                  relating to these Terms, their performance and subject matter.
                  The CPO T&amp;Cs may be subject to different jurisdictions.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-17" className="terms-section">
              <div className="section-marker">
                <span>17</span>
              </div>
              <h2 className="section-title">Severability</h2>
              <div className="subsection">
                <p>
                  {' '}
                  If any provision or part of a provision of these Terms is held
                  or found to be void, invalid or otherwise unenforceable, it
                  will be deemed to be severed to the extent that it is void,
                  invalid or unenforceable and the remainder of that provision
                  (if applicable) and the other provisions set out in these
                  Terms will remain in full force and effect.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <section id="section-18" className="terms-section">
              <div className="section-marker">
                <span>18</span>
              </div>
              <h2 className="section-title">Contacting us</h2>
              <div className="subsection">
                <p>
                  {' '}
                  If you have questions about the iCharge Network, the iCharge
                  Apps, the Website or these Terms, please contact us here.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
              </div>
            </section>
            <div className="terms-footer">
              <div className="footer-decoration"></div>
              <p>
                {' '}
                This document constitutes the entire agreement between you and
                iCharge regarding the use of the iCharge Network, Apps, and
                Website.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <p className="footer-copyright">
                © 2025 iCharge. All rights reserved.
              </p>
            </div>
          </main>
        </div>
        <button id="backToTop" aria-label="Back to top" className="back-to-top">
          <svg
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="m5 12l7-7l7 7m-7 7V5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </button>
      </div>
      <Footer rootClassName="footerroot-class-name15"></Footer>
    </div>
  )
}

export default TermsAndConditions
